import React from 'react';
import {
  Link,
  Redirect
} from 'react-router-dom';

import Pagamento from '../pagamento/Pagamento';
import Login from '../login/Login';
import {WS_PAGAMENTO} from '../../config/Ws';
import "./menu.css";
import LOGO from "../../img/foco90.svg";
import CLOSE from "../../img/x.svg";
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Modal from '../../components/modal.v2/Modal';
import MsgFbGoup from './MsgFbGoup';
import Button from '../../components/buttons/Button';

const URL_LOGOUT = WS.logout;

class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
    }

    this.callLogout = this.callLogout.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.openFbGroup = this.openFbGroup.bind(this);
    this.payNow = this.payNow.bind(this);
    this.callMessage = this.callMessage.bind(this);
  }

  callMessage(e){
    var msg = {
      title: "Atenção",
      text: "Disponível apenas para clientes"
    };
    Dialog.create(msg);
    e.preventDefault();
  }

  getDataUser(){
    const data = window.localStorage.getItem('dadosUser');

    if(data){
      const user = JSON.parse(data);
      return user;
    }
  }

  getNameUser(){
    return window.localStorage.getItem('nome');
  }

  payNow(e){
    e.preventDefault();

    const usuario = window.localStorage.getItem('usuario');
    const senha = window.localStorage.getItem('senha');

    const data = {email: usuario, senha: senha};

    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      usuarioSenha,
      erroLogar,
      erroPlanos
    }
    = this.state.strings;

    const self = this;

    Requisitions({
      url: WS_PAGAMENTO.login,
      data: data,
      sucess:function(data){
        if(data.status){
          if(!data.planos){
            var msg = {
              title: atencao,
              text: erroPlanos
            };
            Dialog.create(msg);
            return false;
          }

          Login.setDataUser({usuario,senha,user:data.user});

          Modal.create({
            content: <Pagamento
            data={data}
            history={self.props.history} />
          });
        }else{
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroLogar
        });
      }
    });
  }

  openFbGroup(e){
    e.preventDefault();

    const user = this.getDataUser();
    Modal.create({
      content: <MsgFbGoup link={user.urlFbGroup} />,
      classes: 'msg-fb-group'
    });
    /*if(user.ativo){
      Modal.create({
        content: <MsgFbGoup link={user.urlFbGroup} />,
        classes: 'msg-fb-group'
      });
    }else{
      const {
        atencao,
        msgGrupoFB
      }
      = this.state.strings;

      var msg = {
        title: atencao,
        text: msgGrupoFB
      };
      Dialog.create(msg);
    }*/
  }

  closeMenu(e) {
    e.preventDefault();

    const menu = document.getElementById('menu');
    menu.classList.remove("open");
  }

  callLogout(e) {
    e.preventDefault();

    window.localStorage.removeItem('usuario');
    window.localStorage.removeItem('senha');

    const self = this;
    Requisitions({
      url: URL_LOGOUT,
      data: {},
      sucess:function(data){
        self.props.history.push('/');
      },
      error:function(data){
      }
    });
  }

  render(){
    const foto = window.dadosUser ? window.dadosUser.foto : '';
    const data = this.getDataUser();
    const nome = this.getNameUser() ? this.getNameUser() : '';
    const btPay = null;
    const sexo = data ? data.sexo : 'F';

    const btEbook = sexo === 'M' ? '' : <LinkItem url="/area-restrita/e-book/" txt="Ebooks"></LinkItem>;

    return(
      <div className="menu" id='menu'>
        <div className='menu-overlay'><a href='#' className='bt-close-menu' onClick={this.closeMenu}><img src={CLOSE} /></a></div>
        <div className="menu-scroll">
          <div className="menu-inner">
            <img src={LOGO} width='170' />
            <div className='box-user-foto'>
              {foto ? (<div className='foto-user'><img src={foto} /></div>) : null}
              <div className='hey-user'>Olá,<br /><span className='name-user truncate-txt'>{nome}</span></div>
              <div className='clear'></div>
            </div>
            <ul>
              <li className="link-menu--item">
                <a href="#" className="bt-fb-group" onClick={this.callMessage}>
                  <div className="link-menu">
                    <span className="link-menu--txt">Comunidade do Facebook</span>
                    <div className="clear"></div>
                  </div>
                </a>
              </li>
              <LinkItem url="/area-restrita/meu-treino/" txt="Meu treino"></LinkItem>
              <LinkItem url="/area-restrita/meu-perfil/" params={{page:"mudar_treino"}} txt="Mudar treino"></LinkItem>
              <LinkItem url="/area-restrita/meu-perfil/" txt="Meu perfil"></LinkItem>
              <LinkItem url="/area-restrita/meu-plano-alimentar/" txt="Orientação nutricional"></LinkItem>
              <LinkItem url="/area-restrita/exercicios/" txt="Exercícios"></LinkItem>
              <LinkItem url="/area-restrita/minhas-medidas/" txt="Minhas medidas"></LinkItem>
              <LinkItem url="/area-restrita/tecnicas/" txt="Técnicas"></LinkItem>
              <LinkItem url="/area-restrita/perguntas-frequentes/" txt="Perguntas frequentes"></LinkItem>
              {/*<LinkItem url="/area-restrita/mensagens/" txt="Mensagens"></LinkItem>*/}
              <li className="link-menu--item">
                <a href='#' onClick={this.callMessage}>
                  <div className="link-menu">
                    <span className="link-menu--txt">Assessoria por Whatsapp</span>
                    <i class="fab fa-whatsapp link-menu--icon-whats"></i>
                    <div className="clear"></div>
                  </div>
                </a>
              </li>
              <LinkItem url="/area-restrita/sobre/" txt="Sobre o Foco90"></LinkItem>

                <li className="link-menu--item">
                  <a href='#' onClick={this.callLogout}>
                    <div className="link-menu">
                      <span className="link-menu--txt">Sair</span>
                      <div className="clear"></div>
                    </div>
                  </a>
                </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const refCallback = () => {
  const menu = document.getElementById('menu');
  menu.classList.remove("open");
}

const LinkItem = ({...props}) => {
  var _class = ' link-menu--icon--material '+props.icon;

  return(
    <li className="link-menu--item">
      <Link to={
              {
                pathname: props.url,
                search: '',
                hash: '',
                state: props.params
              }
            } onClick={refCallback}>
        <div className="link-menu">
          <span className="link-menu--txt">{props.txt}</span>
          <div className="clear"></div>
        </div>
      </Link>
    </li>
  )
}

    ;

export default Menu;



// WEBPACK FOOTER //
// ./src/classes/menu/Menu.js